module.exports = "{{val}}"